const enrichDataLayer = (data): void => {
    if (!window.dataLayer) {
        return;
    }

    const dataLayerPayload = {
        event: 'vertical_page_perseus_page_load',
        ...data,
    };
    window.dataLayer.push(dataLayerPayload);
};

export default enrichDataLayer;
